import React, { useState, useEffect } from 'react';
import { useRole } from '../../context/RoleContext';
import { Link } from 'react-router-dom';
import { PlusIcon, PencilIcon, TrashIcon } from '@heroicons/react/24/outline';
import Pagination from '../common/Pagination';
import { useAuth } from '../../context/AuthContext';
import Swal from 'sweetalert2';
import { useRoutePath } from '../../utils/getRoutePath';
  
const RoleList = () => {
  const { roles, getRoles, deleteRole,paginate,formErrors,clearErrors } = useRole();
  const [searchTerm, setSearchTerm] = useState('');
  const [statusFilter, setStatusFilter] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const { user } = useAuth();
  const [showAddBtn, setShowAddBtn] = useState(true);
  const [showDeleteBtn, setShowDeleteBtn] = useState(true);
  const [filteredRoles, setFilteredRoles] = useState([]);
  const getRoutePath = useRoutePath();
  const [totalPages,setTotalPages] = useState(1)
  const [sortConfig, setSortConfig] = useState({
    key: 'created_at',
    direction: 'desc'
  });
 
  useEffect(() => {
    if (user.role_id !== 1 && roles?.data?.length >= 1) {
      setShowAddBtn(false);
    }
    if (user.role_id !== 1) {
      setShowDeleteBtn(false);
    }
    const params = new URLSearchParams(window.location.search);
    const page = parseInt(params.get('page')) || 1;
    setCurrentPage(page)
    setSearchTerm(params.get('q') || '')
    setStatusFilter(params.get('active') || '')
     
  }, [user,roles]);
 
  
  const filtersData = (key,value,arrayFilters = []) => {
     
    const applyFilters = async (filterDataVal) => {
      
        let filters = {};
        const newUrl = new URL(window.location);
        if (filterDataVal['q']?.key === 'q') {
          filters.q = filterDataVal['q']?.value;
          if(filterDataVal['q']?.value){
            setSearchTerm(filterDataVal['q'].value)
            newUrl.searchParams.set('q', filterDataVal['q'].value);
          }else{
            newUrl.searchParams.delete('q');
          }
        }else if(searchTerm){
          filters.q = searchTerm;
          newUrl.searchParams.set('q', searchTerm);
        } else{
          newUrl.searchParams.delete('q');
        }
  
        if(filterDataVal['active']?.key === 'active'){
            filters.active = filterDataVal['active']?.value;
            if(filterDataVal['active']?.value){
              setStatusFilter(filterDataVal['active'].value)
              newUrl.searchParams.set('active', filterDataVal['active'].value);
            }else{
              newUrl.searchParams.delete('active');
            }
        }else if(statusFilter){
          filters.active = statusFilter;
          newUrl.searchParams.set('active', statusFilter);
        } else{
          newUrl.searchParams.delete('active');
        }
        newUrl.searchParams.delete('page');
        window.history.pushState({}, '', newUrl);
        
        const params = new URLSearchParams(window.location.search);
        const page = parseInt(params.get('page')) || 1;
        if(Object.keys(filters).length > 0){
          let response = await getRoles(page,filters);
      
          if(response?.data){
          setTotalPages(response?.last_page ? response.last_page : 1)
          setFilteredRoles(response?.data);
          setCurrentPage(page)
          }
        }
         
    };
 
      let filterDataVal = {};
      if(arrayFilters.length > 0){
        arrayFilters.forEach(filter => {
          filterDataVal[filter.key] = {
            key:filter.key,value:filter.value
          } 
          
        })
      }else{
        filterDataVal[key] = {
          key:key,value:value
        } 
      }
      applyFilters(filterDataVal);
  }
 
  useEffect(() => {
    setTotalPages(roles?.last_page ? roles.last_page : 1)
    if (roles?.data) {
      let filtered = [...roles?.data];
      
      // Apply sorting
      if (sortConfig.key) {
        filtered.sort((a, b) => {
          let aValue = a[sortConfig.key];
          let bValue = b[sortConfig.key];

          if (sortConfig.key.includes('.')) {
            const fields = sortConfig.key.split('.');
            aValue = fields.reduce((obj, field) => obj?.[field], a);
            bValue = fields.reduce((obj, field) => obj?.[field], b);
          }

          if (aValue === undefined || aValue === null) aValue = '';
          if (bValue === undefined || bValue === null) bValue = '';

          if (typeof aValue === 'boolean') {
            return sortConfig.direction === 'asc' ? (aValue ? 1 : -1) : (aValue ? -1 : 1);
          }

          if (sortConfig.key === 'created_at' || sortConfig.key === 'updated_at') {
            const dateA = new Date(aValue);
            const dateB = new Date(bValue);
            return sortConfig.direction === 'asc' ? dateA - dateB : dateB - dateA;
          }

          return sortConfig.direction === 'asc'
            ? String(aValue).localeCompare(String(bValue))
            : String(bValue).localeCompare(String(aValue));
        });
      }

      setFilteredRoles(filtered);
    }
  }, [roles, searchTerm, statusFilter, sortConfig]);

  const handleSort = (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key, direction });
  };

  const SortableHeader = ({ columnKey, children }) => (
    <th 
      className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer"
      onClick={() => handleSort(columnKey)}
    >
      <div className="flex items-center">
        {children}
        {sortConfig.key === columnKey && (
          <span className="ml-1">
            {sortConfig.direction === 'asc' ? '↑' : '↓'}
          </span>
        )}
      </div>
    </th>
  );
  
 // const totalPages = roles?.last_page ? roles.last_page : 1;
  const currentItems = filteredRoles;

  const handlePageChange = (page) => {
     
    setCurrentPage(page);
    let filters = {};
    if(searchTerm){
      filters.q = searchTerm;
    }
    if(statusFilter){
      filters.active = statusFilter;
    }
    getRoles(page,filters);
    
    const newUrl = new URL(window.location);
    newUrl.searchParams.set('page', page);
    window.history.pushState({}, '', newUrl);
  };
  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    });

    if (result.isConfirmed) {
      try {
        const response = await deleteRole(id);
        if (response.status === 200) {
          Swal.fire(
            'Deleted!',
            'Role has been deleted.',
            'success'
          );
        }
      } catch (error) {
        Swal.fire(
          'Error!',
          'Failed to delete role.',
          'error'
        );
      }
    }
  };

  return (
    <div className="py-6">
      {showAddBtn ? (
        <div className="max-w-10xl mx-auto px-4 sm:px-6 md:px-8 mb-3">
          <div className="flex justify-between items-center">
            <h1 className="text-2xl font-semibold text-gray-900">Roles</h1>
            <Link
              to={getRoutePath(`/roles/create`)}
              className="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-[#009efb] hover:bg-[#0089db] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#009efb]"
            >
              <PlusIcon className="w-4 h-4 mr-2" />
              Add New Role
            </Link>
          </div>
        </div>
      ) : null}

      <div className="max-w-10xl mx-auto px-4 sm:px-6 md:px-8">
        <div className="bg-white rounded-lg shadow-md mb-3">
           
          <div className="mb-4 grid grid-cols-1 md:grid-cols-2 p-5 gap-4">
            <div>
              <input
                type="text"
                placeholder="Search roles..."
                value={searchTerm}
                onChange={(e) => filtersData('q',e.target.value)}
                className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            <div>
              <select
                value={statusFilter}
                onChange={(e) => filtersData('active',e.target.value)}
                className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                <option value="all">All Status</option>
                <option value="1">Active</option>
                <option value="0">Inactive</option>
              </select>
            </div>
          </div>
        </div>

        {formErrors && (
          (typeof formErrors === 'string' || formErrors.general) ? (
            <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 mb-3 rounded relative mt-2" role="alert">
              <button
                type="button"
                className="absolute top-0 right-0 mt-2 mr-3 text-red-700 font-bold text-xl leading-none focus:outline-none"
                onClick={() => clearErrors()}
                aria-label="Close"
              >
                &times;
              </button>
              {!formErrors.general && (<strong className="font-bold">Error: </strong>)}
              <span className="block sm:inline">{formErrors.general || formErrors}</span>
            </div>
          ) : ''
        )}
 
        <div className="bg-white rounded-lg shadow-md mb-3">
          <div className="px-4 py-5 sm:px-6">
            <h3 className="text-lg leading-6 font-medium text-gray-900">Role Details</h3>
            <p className="mt-1 max-w-2xl text-sm text-gray-500">Role information and details.</p>
          </div>

          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <SortableHeader columnKey="name">Name</SortableHeader>
                  <SortableHeader columnKey="active">Status</SortableHeader>
                  <SortableHeader columnKey="created_at">Created At</SortableHeader>
                  <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {currentItems?.length === 0 ? (
                  <tr>
                    <td colSpan="5" className="px-6 py-4 text-center text-gray-500">
                      <div className="flex flex-col items-center justify-center space-y-4">
                        <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center">
                          <PlusIcon className="w-8 h-8 text-gray-400" />
                        </div>
                        <div>
                          <h3 className="text-lg font-medium text-gray-900 mb-2">No Role Found</h3>
                          <p className="text-gray-500 mb-4">Get started by creating a new role</p>
                        </div>
                      </div>
                    </td>
                  </tr>
                ) : (
                  currentItems?.map((role) => (
                    <tr key={role.id}>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="text-sm font-medium text-gray-900">{role.name}</div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <span
                          className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${
                            role.active
                              ? 'bg-green-100 text-green-800'
                              : 'bg-red-100 text-red-800'
                          }`}
                        >
                          {role.active ? 'Active' : 'Inactive'}
                        </span>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                        {new Date(role.created_at).toLocaleDateString()}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                        <Link  
                          to={getRoutePath(`/roles/edit/${String(role.id)}`)}
                          className="text-[#009efb] hover:text-[#0089db] mr-4"
                        >
                          <PencilIcon className="w-4 h-4 inline" />
                        </Link>
                        {showDeleteBtn && (
                          <button
                            onClick={() => handleDelete(String(role.id))}
                            className="text-red-600 hover:text-red-900"
                          >
                            <TrashIcon className="w-4 h-4 inline" />
                          </button>
                        )}
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
         
          {paginate && currentItems?.length > 0 && (
            <div className="px-4 py-3 border-t border-gray-200">
              <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={handlePageChange}
              />
            </div>
          )}
        </div>

       
      </div>
 
    </div>
  );
};

export default RoleList; 